import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '.';
import { UUID } from 'crypto';
import { handleGlobalSearch } from '@/utils';
import { EventType } from '@/utils/types';

export const eventsApi = createApi({
	reducerPath: 'eventsApi',
	tagTypes: ['events', 'sessions'],
	baseQuery: baseQuery,
	refetchOnMountOrArgChange: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({
		getEvents: builder.query({
			query: ({ page, filters }: { page: number; filters: any }) => ({
				url: `events`,
				params: { page, ...handleGlobalSearch(filters, ['name']) },
			}),
			providesTags: ['events'],
		}),
		getEventById: builder.query({
			query: ({ id }: { id: string }) => ({
				url: `events/${id}`,
			}),
			providesTags: ['events'],
		}),
		getEventUshers: builder.query({
			query: ({ id }: { id: string }) => ({
				url: `events/${id}/ushers`,
			}),
		}),
		getEventAttendees: builder.query({
			query: ({ id, page, filters }: { id: string; page: number; filters: any }) => ({
				url: `events/${id}/attendees`,
				params: { page, ...handleGlobalSearch(filters, ['name']) },
			}),
		}),

		getEventSessions: builder.query({
			query: ({ id }: { id: string }) => ({
				url: `events/${id}/sessions`,
			}),
			providesTags: ['sessions'],
		}),
		getEventAttendeesStatistics: builder.query({
			query: ({ id }: { id: string }) => ({
				url: `events/${id}/attendees-statistics`,
			}),
		}),
		deleteEvent: builder.mutation({
			query: (id: UUID) => ({
				url: `events/${id}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['events'],
		}),

		addEvent: builder.mutation({
			query: (body: EventType) => ({
				url: `events`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['events'],
		}),
		updateEvent: builder.mutation({
			query: ({ id, ...payload }: Partial<EventType>) => ({
				url: `events/${id}`,
				method: 'PATCH',
				body: payload,
			}),
			invalidatesTags: ['events'],
		}),
		uploadHeaderImage: builder.mutation({
			query: ({ id, body }) => ({
				url: `events/${id}/header-image`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['events'],
		}),
		setEventUsher: builder.mutation({
			query: ({ id, body }) => ({
				url: `events/${id}/set-ushers`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['events'],
		}),
	}),
});

export const {
	useGetEventAttendeesQuery,
	useGetEventUshersQuery,
	useAddEventMutation,
	useGetEventByIdQuery,
	useUpdateEventMutation,
	useDeleteEventMutation,
	useGetEventsQuery,
	useUploadHeaderImageMutation,
	useSetEventUsherMutation,
	useGetEventSessionsQuery,
	useGetEventAttendeesStatisticsQuery,
} = eventsApi;
